import { downloadExternalEducationReportAttachment } from '../../../api/education';
import { ExternalEducationReport } from '../../../types/education';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: ExternalEducationReport;
}

function ExternalEducationPreviewView({ detail }: Props) {
  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>사외교육 수강 보고서</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            문서번호
            <input value={detail.reportNo || ''} disabled />
          </label>
          <label className="is-span-2">
            과정명 *
            <input value={detail.courseName || ''} disabled />
          </label>
          <label>
            주관기관
            <input value={detail.organizer || ''} disabled />
          </label>
          <label>
            수강자
            <input value={detail.traineeName || ''} disabled />
          </label>
          <label>
            시작일
            <input type="date" value={detail.periodFrom || ''} disabled />
          </label>
          <label>
            종료일
            <input type="date" value={detail.periodTo || ''} disabled />
          </label>
          <label>
            부서
            <input value={detail.department || ''} disabled />
          </label>
          <label>
            시간
            <input value={detail.hours || ''} disabled />
          </label>
          <label>
            비용
            <input value={detail.costText || ''} disabled />
          </label>
          <label className="is-span-2">
            교육내용
            <textarea rows={4} value={detail.content || ''} disabled />
          </label>
          <label className="is-span-2">
            업무 적용 계획
            <textarea rows={3} value={detail.applicationPlan || ''} disabled />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={2} value={detail.remark || ''} disabled />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="edu-plan-card__title" style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>첨부파일</h3>
        </div>
        <p className="edu-plan-hint">수료증, 강의자료, 영수증 등을 첨부할 수 있습니다.</p>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadExternalEducationReportAttachment(
              detail.reportId,
              file.attachmentId,
              file.fileName
            );
          }}
        />
      </section>
    </div>
  );
}

export default ExternalEducationPreviewView;
